module.exports = __webpack_public_path__ + "static/media/hydpink.ffc4997d.svg";